import './Register.scss'

interface RegisterProps {
	lang: String
}

const Register: React.FC<RegisterProps> = (props: RegisterProps) => {
	return (<div className="register">
		{props.lang==="nl"
		? <><h1>Inschrijven</h1>
			<p>Women at the top komt terug op 26 mei 2026, met weer een inspirerende avond voor ambitieuze vrouwen die willen groeien, verbinden en empowered willen worden.<br/></p>
			<p>Ontmoet geweldige vrouwen via ons kenmerkende speed-dating netwerkformat, deel ervaringen, stel vragen en bouw waardevolle connecties op, alles in een bruisende sfeer met heerlijke hapjes en drankjes.<br/></p>
			<p>Dit jaar voegen we interactieve workshops toe voor nog meer diepgang, inspiratie en persoonlijke ontwikkeling. Mis het niet!<br/></p></>
        : <><h1>Register</h1>
			<p>Women at the Top returns on May 26th, 2026, bringing another inspiring evening for ambitious women ready to grow, connect, and be empowered.</p>
			<p>Meet incredible women through our signature speed-dating networking format, share experiences, ask questions, and build meaningful connection, all in a vibrant atmosphere with great snacks and drinks.<br /></p>
			<p>This year, we're adding interactive workshops for even more depth, inspiration, and personal development. Don't miss out!<br /></p>	</>
		}
		<div className='mt-5' style={{height: "105vh"}}>
            <iframe title="Registration form" src="https://docs.google.com/forms/d/e/1FAIpQLSfY-HMQIyihKOpAm0V7Kp3rdfb3kMvB8-0pAiNBDsavuqY7HA/viewform?embedded=true" style={{margin:"0"}} width="100%" height="100%" frameBorder="0" marginHeight={0} marginWidth={0}>Laden…</iframe>
        </div>
	</div>)
}

export default Register